import { ResponsiveContainer, LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip } from "recharts"

const formatCompact = (value) => {
    const n = Number(value ?? 0)
    if (n >= 1_000_000_000) return `${(n / 1_000_000_000).toFixed(1)}M`
    if (n >= 1_000_000) return `${(n / 1_000_000).toFixed(1)}jt`
    if (n >= 1_000) return `${(n / 1_000).toFixed(0)}rb`
    return String(n)
}

const formatTooltip = (value) =>
    new Intl.NumberFormat("id-ID", {
        style: "currency",
        currency: "IDR",
        minimumFractionDigits: 0,
        maximumFractionDigits: 0,
    }).format(Number(value ?? 0))

const SalesTrendChart = ({ data }) => {
    const safeData = Array.isArray(data) ? data : []

    return (
        <div className="h-64 -ml-2">
            <ResponsiveContainer width="100%" height="100%">
                <LineChart data={safeData} margin={{ top: 10, right: 20, left: 0, bottom: 0 }}>
                    <CartesianGrid strokeDasharray="3 3" stroke="#e5e7eb" />
                    <XAxis
                        dataKey="label"
                        tick={{ fontSize: 11, fill: "#737373" }}
                        tickLine={false}
                        axisLine={{ stroke: "#e5e7eb" }}
                    />
                    <YAxis
                        tick={{ fontSize: 11, fill: "#737373" }}
                        tickLine={false}
                        axisLine={{ stroke: "#e5e7eb" }}
                        tickFormatter={formatCompact}
                    />
                    <Tooltip
                        formatter={(value) => [formatTooltip(value), "Penjualan"]}
                        contentStyle={{ fontSize: 12, borderRadius: 8, border: "1px solid #e5e7eb" }}
                    />
                    <Line
                        type="monotone"
                        dataKey="value"
                        stroke="#171717"
                        strokeWidth={2}
                        dot={{ r: 3, fill: "#171717" }}
                        activeDot={{ r: 5 }}
                    />
                </LineChart>
            </ResponsiveContainer>
        </div>
    )
}

export default SalesTrendChart
